// extracted by mini-css-extract-plugin
export default {"Undo":"Undo_Undo__S8knm","UndoMobile":"Undo_UndoMobile__xFd3i"};